export const setIPOData = (data) =>
  ({
    type: 'SET_IPO_DATA',
    data
  })

export const setIPOContracts = (data) => ({
  type: 'SET_IPO_CONTRACTS',
  data
})

export const removeIPODetail = () => ({
  type: 'REMOVE_IPO_DETAILS',
})

export const setIpoConfig = (data) => ({
  type:"SET_IPO_CONFIG",
  data
})

export const removeIpoConfig = (data) => ({
  type:"REMOVE_IPO_CONFIG",
  data
})